<div>
    <div class="row m-0">
        <div class="col"></div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary" (click)="addGroup(0)" [disabled]="isDisabled">
                <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Group':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Asset Group Master
        </div>
        <div class="card-body">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th style="width:20%;">Group Name</th>
                        <th style="width:20%;">Group Code</th>
                        <th>Description</th>
                        <th style="width: 5px;">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of TableDatas; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td style="width:20%;"> {{TableData['AssetGroupName']}}</td>
                        <td style="width:20%;"> {{TableData['AssetGroupCode']}}</td>
                        <td>{{TableData['Description']}}</td>
                        <td style="width: 5px;">
                            <div class="text-center"><i (click)="addGroup(TableData['ESS_AssetGroupMasterId'])"
                                    class="bi bi-pencil-square text-warning"></i></div>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>

    </div>
</div>